import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import { db } from 'firebase/fbConfig.js';

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const PinUserForm = (props) => {
    const [dispatchers, setDispatchers] = useState({});
    const [dispatcher, setDispatcher] = useState(props.dispatcher);

    const getDispatchers = () => {
        db.collection('haney-vendors').doc('SdmzdeID9QfexkQymvqU').collection('users').where('role', '==', 'Employee').get()
            .then(snapshot => {
                setDispatchers(Object.fromEntries(snapshot.docs.map(doc => [
                    doc.id,
                    doc.data().name,
                ])));
            })
    }

    const changeDispatcher = e => {
        const { value } = e.target;
        const currValue = _.clone(dispatcher);

        setDispatcher(value);
        db.collection('haney-orders').doc(props.orderID).set({
            dispatcherID: value,
            dispatcherName: dispatchers[value]
        }, { merge: true })
            .then(() => console.log('success changing dispatcher'))
            .catch(err => {
                setDispatcher(currValue);
                console.error(err);
            });
    }

    useEffect(() => {
        if (dispatcher !== props.dispatcher) setDispatcher(props.dispatcher);
    }, [props.dispatcher]);

    useEffect(() => {
        getDispatchers()
    }, []);
    return (
        <FormControl
            fullWidth
        >
            <InputLabel
                htmlFor="dispatcherSelected"
            >
                Dispatchers:
            </InputLabel>
            <Select
                value={dispatcher}
                onChange={changeDispatcher}
                inputProps={{
                    id: 'dispatcherSelected',
                    name: 'dispatcherSelected'
                }}
            >
                {Object.entries(dispatchers).map(([id, name]) => (
                    <MenuItem
                        value={id}
                        key={id}
                    >
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default PinUserForm;


// WEBPACK FOOTER //
// ./src/components/Forms/PinUserForm.jsx